if (!customElements.get('pm-mobile-home-sales')) {
  class PMMobileHomeSales extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.setupProducts();
      this.setupFiber();
      this.setupTimeline();
      this.setupBuybar();
    }

    centeredScrollLeft(rail, item) {
      return item.offsetLeft - (rail.clientWidth - item.offsetWidth) / 2;
    }

    nearestCenteredIndex(rail, items) {
      const railCenter = rail.scrollLeft + rail.clientWidth / 2;
      return items.reduce(
        (best, item, index) => {
          const itemCenter = item.offsetLeft + item.offsetWidth / 2;
          const distance = Math.abs(itemCenter - railCenter);
          return distance < best.distance ? { index, distance } : best;
        },
        { index: 0, distance: Infinity }
      ).index;
    }

    setupProducts() {
      const rail = this.querySelector('[data-pm-product-rail]');
      const cards = Array.from(this.querySelectorAll('[data-pm-product-card]'));
      const current = this.querySelector('[data-pm-product-current]');
      const progress = this.querySelector('[data-pm-product-progress]');
      const previous = this.querySelector('[data-pm-product-prev]');
      const next = this.querySelector('[data-pm-product-next]');
      if (!rail || cards.length === 0 || !current || !progress || !previous || !next) return;

      let index = 0;
      const update = (nextIndex) => {
        index = Math.max(0, Math.min(cards.length - 1, nextIndex));
        current.textContent = String(index + 1);
        progress.style.transform = `translateX(${index * 100}%)`;
        previous.disabled = index === 0;
        next.disabled = index === cards.length - 1;
      };
      const scrollTo = (nextIndex) => {
        const card = cards[nextIndex];
        if (!card) return;
        rail.scrollTo({ left: this.centeredScrollLeft(rail, card), behavior: 'smooth' });
        update(nextIndex);
      };

      previous.addEventListener('click', () => scrollTo(index - 1));
      next.addEventListener('click', () => scrollTo(index + 1));
      rail.addEventListener(
        'scroll',
        () => update(this.nearestCenteredIndex(rail, cards)),
        { passive: true }
      );
      update(0);
    }

    setupFiber() {
      const rail = this.querySelector('[data-pm-fiber-rail]');
      const cards = Array.from(this.querySelectorAll('[data-pm-fiber-card]'));
      const dots = Array.from(this.querySelectorAll('[data-pm-fiber-dot]'));
      if (!rail || cards.length === 0 || dots.length === 0) return;

      const update = (index) => {
        dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', String(dotIndex === index));
        });
      };
      const scrollTo = (index) => {
        const card = cards[index];
        if (!card) return;
        rail.scrollTo({ left: this.centeredScrollLeft(rail, card), behavior: 'smooth' });
        update(index);
      };

      dots.forEach((dot, index) => dot.addEventListener('click', () => scrollTo(index)));
      rail.addEventListener(
        'scroll',
        () => update(this.nearestCenteredIndex(rail, cards)),
        { passive: true }
      );
      update(0);
    }

    setupTimeline() {
      const rail = this.querySelector('[data-pm-timeline-rail]');
      const slides = Array.from(this.querySelectorAll('[data-pm-timeline-slide]'));
      const tabsRail = this.querySelector('[data-pm-timeline-tabs]');
      const tabs = Array.from(this.querySelectorAll('[data-pm-timeline-tab]'));
      const current = this.querySelector('[data-pm-timeline-current]');
      const progress = this.querySelector('[data-pm-timeline-progress]');
      const previous = this.querySelector('[data-pm-timeline-prev]');
      const next = this.querySelector('[data-pm-timeline-next]');
      if (
        !rail ||
        slides.length === 0 ||
        !tabsRail ||
        tabs.length !== slides.length ||
        !current ||
        !progress ||
        !previous ||
        !next
      ) {
        return;
      }

      let index = 0;
      const update = (nextIndex) => {
        index = Math.max(0, Math.min(slides.length - 1, nextIndex));
        current.textContent = String(index + 1);
        progress.style.transform = `translateX(${index * 100}%)`;
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
        tabs.forEach((tab, tabIndex) => {
          tab.setAttribute('aria-selected', String(tabIndex === index));
        });

        const activeTab = tabs[index];
        tabsRail.scrollTo({
          left: activeTab.offsetLeft - (tabsRail.clientWidth - activeTab.offsetWidth) / 2,
          behavior: 'smooth'
        });
      };
      const scrollTo = (nextIndex) => {
        const slide = slides[nextIndex];
        if (!slide) return;
        rail.scrollTo({ left: this.centeredScrollLeft(rail, slide), behavior: 'smooth' });
        update(nextIndex);
      };

      tabs.forEach((tab, tabIndex) => {
        tab.addEventListener('click', () => scrollTo(tabIndex));
      });
      previous.addEventListener('click', () => scrollTo(index - 1));
      next.addEventListener('click', () => scrollTo(index + 1));
      rail.addEventListener(
        'scroll',
        () => update(this.nearestCenteredIndex(rail, slides)),
        { passive: true }
      );
      update(0);
    }

    setupBuybar() {
      const hero = document.querySelector('#MainContent > [id*="__hero_"]');
      const finalSection = this.querySelector('[data-pm-final]');
      const buybar = this.querySelector('[data-pm-buybar]');
      if (!hero || !finalSection || !buybar) return;

      const update = () => {
        const heroBottom = hero.offsetTop + hero.offsetHeight * 0.78;
        const finalTop = finalSection.getBoundingClientRect().top + window.scrollY;
        const visible =
          window.innerWidth <= 749 &&
          window.scrollY > heroBottom &&
          window.scrollY < finalTop - window.innerHeight * 0.45;

        this.classList.toggle('is-buybar-visible', visible);
        buybar.setAttribute('aria-hidden', String(!visible));
      };

      this._buybarUpdate = update;
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }

    disconnectedCallback() {
      if (!this._buybarUpdate) return;
      window.removeEventListener('scroll', this._buybarUpdate);
      window.removeEventListener('resize', this._buybarUpdate);
    }
  }

  customElements.define('pm-mobile-home-sales', PMMobileHomeSales);
}
